export const LARGE_SCREEN_TOP_VALUE = 13;
export const SMALL_SCREEN_TOP_VALUE = 20;

export const SMALL_ITEM_ICONS_UIDS = ['help'];
